export default __webpack_public_path__ + "static/media/eye.0c702601.svg";